// Vue framework imports
import { createApp } from 'vue';
import { createHead } from '@vueuse/head';

// Local imports
import App from './App.vue';
import { initializeFirebase } from './utils/services';
import { removeDuplicateMetaTags } from './utils/seo';
import { initLayoutHandling } from './utils/layout';
import { initializeTawkTo } from './utils/services';

// Import CSS
import './assets/css/styles.css';
import './assets/css/responsive.css';
import './assets/css/sidebarLayout.css';

// Initialize the app regardless of Firebase status
const app = createApp(App);
const head = createHead();
app.use(head);

// Try to initialize Firebase but don't block app startup if it fails
initializeFirebase()
    .then(({ app: firebaseApp, analytics }) => {
        if (firebaseApp && analytics) {
            console.log("Firebase successfully initialized");
            
            // Make Firebase services available globally if needed
            window.firebaseApp = firebaseApp;
            window.firebaseAnalytics = analytics;
        } else {
            console.log("Firebase configuration unavailable - continuing without Firebase");
        }
    })
    .catch(error => {
        console.error("Error initializing Firebase:", error);
        // Continue with the app even if Firebase fails to initialize
        console.log("Application will continue without Firebase functionality");
    })
    .finally(() => {
        // Mount the app regardless of Firebase status
        app.mount('#app');
        
        // Remove any duplicate meta tags after app is mounted
        // This helps with SSR and prevents conflicts between static and dynamic tags
        setTimeout(removeDuplicateMetaTags, 500);
        
        // Initialize layout handling
        setTimeout(initLayoutHandling, 1000);
        
        // Initialize Tawk.to chat widget
        setTimeout(initializeTawkTo, 1500);
    });
